import { render } from "./NotificationEdit.vue?vue&type=template&id=1ff76be9&ts=true"
import script from "./NotificationEdit.vue?vue&type=script&lang=ts"
export * from "./NotificationEdit.vue?vue&type=script&lang=ts"

import exportComponent from "/dados/apps/pdcrm/app_atual/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__